export default __webpack_public_path__ + "static/media/speciality_id_5.403b393d.png";